import { Navbar } from '@/components/catalyst-ui/navbar'
import { WorkspaceNavbar } from './WorkspaceNavbar'
import { ProjectNavbar } from './ProjectNavbar'
import { useSelectionStore } from '@/state/selection.store'
import { useLocation } from 'react-router-dom'

export default function AppNavbar() {
  const { activeProjectId } = useSelectionStore()
  const location = useLocation()
  const isWorkspaceLevelRoute =
    location.pathname === '/' ||
    location.pathname === '/projects' ||
    location.pathname === '/draft-generations'

  return (
    <>
      <Navbar className="bg-[#27272A]">
        {activeProjectId && !isWorkspaceLevelRoute ? <ProjectNavbar /> : <WorkspaceNavbar />}
      </Navbar>
    </>
  )
}
